import EthereumProvider from './EthereumProvider'

export default EthereumProvider
